<template>
  <v-container text-center>
    <v-row
      row
      wrap>
      <v-col
        lg4
        align="center"
        class="mt-5">
        西暦{{ birthday.year }}年{{ birthday.month }}月
        {{ birthday.day }}日生まれの命式
        <hr class="mt-1">
        <table
          border="1"
          class="sanmei_table mt-3">
          <tr align="center">
            <td class="bg-gray w-33">
              日柱
            </td>
            <td class="bg-gray w-33">
              月柱
            </td>
            <td class="bg-gray w-33">
              年柱
            </td>
          </tr>
          <tr align="center">
            <td class="col_1">
              {{ userMeishiki.santyu.day1 }}
            </td>
            <td class="col_2">
              {{ userMeishiki.santyu.month1 }}
            </td>
            <td class="col_3">
              {{ userMeishiki.santyu.year1 }}
            </td>
          </tr>
          <tr align="center">
            <td class="col_1">
              {{ userMeishiki.santyu.day2 }}
            </td>
            <td class="col_2">
              {{ userMeishiki.santyu.month2 }}
            </td>
            <td class="col_3">
              {{ userMeishiki.santyu.year2 }}
            </td>
          </tr>
        </table>

        <v-btn
          class="mx-4 my-4"
          dark
          color="primary"
          :to="{ name: 'calendar' }">
          <v-icon>mdi-calendar</v-icon>
          カレンダーへ
        </v-btn>
      </v-col>
      <v-col lg4>
        <v-form ref="form">
          <v-text-field
            v-model="birthday.year"
            label="西暦【必須】"
            placeholder="1970"
            :rules="[required]"
            suffix="年" />
          <v-text-field
            v-model="birthday.month"
            label="月【必須】"
            placeholder="1"
            :rules="[required]" />
          <v-text-field
            v-model="birthday.day"
            label="日【必須】"
            placeholder="1"
            :rules="[required]" />
          <v-radio-group
            v-model="birthday.sex"
            label="性別"
            row>
            <v-radio
              label="男"
              value="男" />
            <v-radio
              label="女"
              value="女" />
          </v-radio-group>
          <v-text-field
            v-model="userInfo.shimei"
            label="氏名【必須】"
            placeholder="祭研 太郎"
            :rules="[required]" />
          <v-text-field
            v-model="userInfo.shimeiKana"
            label="ふりがな"
            placeholder="祭研 太郎" />
          <v-text-field
            v-model="userInfo.mail"
            label="メールアドレス【必須】"
            placeholder="example@example.com"
            :rules="[required]" />
          <!-- <v-text-field
            v-if="!isRegisteredUser"
            v-model="userInfo.password"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[required, min, format]"
            :type="showPassword ? 'text' : 'password'"
            name="input-password"
            label="ログインパスワード"
            hint="6文字以上の半角英数字で入力してください"
            autocomplete="off"
            counter
            @click:append="showPassword = !showPassword" /> -->
          <v-select
            v-model="userInfo.selectedJobItem"
            :items="jobItems"
            filled
            label="職業【必須】"
            :rules="[required]" />
          <v-select
            v-model="userInfo.selectedUsecase"
            :items="usecaseItems"
            filled
            label="用途" />
          <v-textarea
            v-model="userInfo.learn"
            label="どのようにこのサイトを知ったか？"
            placeholder="友人の紹介 など" />
          <div style="text-align:left;">
            案内メールをお送りしてもよろしいですか？
          </div>
          <v-radio-group
            v-model="userInfo.receiveMail"
            row>
            <v-radio
              label="YES"
              value="YES" />
            <v-radio
              label="NO"
              value="NO" />
          </v-radio-group>
          <update-confirm ref="updateConfirm" />
          <v-btn
            block
            large
            color="info"
            class="mt-4 font-weight-bold"
            width="50"
            @click="validate">
            更新
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapState, mapGetters } from 'vuex'
import { functions } from '@/plugins/firebase'
import UpdateConfirm from '../components/UpdateConfirm.vue'

export default {
  components: {
    UpdateConfirm,
  },
  data: () => ({
    jobItems: ['経営者・役員', '自営業', '会社員', '学生', '上記以外'],
    usecaseItems: [
      '事業の経営判断',
      '新規出発の参考に利用',
      '算命学に興味がある',
      'プライベート目的で利用',
      '上記以外',
    ],
    showPassword: false,
    required: (v) => !!v || '必須入力です',
    min: (v) =>
      v && v.length >= 6 || 'パスワードは6文字で入力してください',
    format: (v) =>
      /^[\w-]{6,72}$/.test(v) ||
            'パスワードは半角英数字で入力してください',
    isInputValid: false,
  }),
  computed: {
    ...mapState({
      birthday: 'user_birthday',
      userMeishiki: 'user_meishiki',
      userInfo: 'user_info',
      userName: 'userName',
    }),
    ...mapGetters(['isRegisteredUser']),
  },
  methods: {
    validate() {
      this.isInputValid = this.$refs.form.validate()
      // validationでエラーがなければ、確認ダイアログを開く
      if (this.isInputValid) {
        this.$refs.updateConfirm.open()
      }
    },
    sendBirthDay: async function() {
      const func = functions.httpsCallable('registerUserInfo')
      const args = {
        birthday: this.birthday,
        shimei: this.userInfo.shimei,
        shimeiKana: this.userInfo.shimeiKana,
        mail: this.userInfo.mail,
        job: this.userInfo.selectedJobItem,
        usecase: this.userInfo.selectedUsecase,
        learn: this.userInfo.learn,
        receiveMail: this.userInfo.receiveMail,
      }
      await func(args).then((res) => {
        this.registerUserMeishiki({
          userMeishiki: res.data.meishiki,
          birthday: this.birthday,
          userInfo: this.userInfo,
        })
      })
    },
    ...mapActions(['registerUserMeishiki', 'registerUserInfo']),
  },
}
</script>
<style scoped lan="scss">
.bg-black {
    background-color: black;
    color: white;
}
.sanmei_table {
    font-size: 24px;
    border-collapse: collapse;
}

.post-link {
    display: inline-block;
    word-break: break-all;
    padding: 2px 8px;
    border-radius: 5px;
    text-transform: none !important;
    white-space: normal;
    max-width: calc(100% - 30px);
    height: inherit !important;
}
</style>
